import React, { useCallback } from 'react';

import { mapLinks } from '../../defaultLinks';
import BaseMenu from '../BaseMenu';
import BaseMenuSection from '../BaseMenuSection';

interface MapsMenuProps {
  onClickLink?: (clickProperties: any, closeMobileMenu: boolean) => void;
}

const MapsMenu = ({ onClickLink }: MapsMenuProps) => {
  const onClickHandler = useCallback(
    (properties: any, closeMobileMenu: boolean) => {
      if (onClickLink) {
        onClickLink(
          {
            name: 'Clicked Main Nav',
            properties: {
              ...properties,
              tabName: 'Maps',
              clickEndLocation: 'Maps',
            },
          },
          closeMobileMenu,
        );
      }
    },
    [onClickLink],
  );

  return (
    <BaseMenu testId="maps-menu">
      <BaseMenuSection links={mapLinks} onClick={onClickHandler} />
    </BaseMenu>
  );
};

export default MapsMenu;
